var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bridge"},[_c('img',{class:['line', { glow: _vm.glow }],attrs:{"src":_vm.bridgeImage,"alt":""}}),_vm._l((6),function(i){return _c('img',{key:i,class:("dot dot" + i),attrs:{"src":_vm.bridgeDotImage(i),"alt":""}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }